module.exports = __webpack_public_path__ + "img/width_1.55ba31a3.png";